import type { VariantWithTemplateSelectFragment } from '~/api/graphql/fragments/variant.generated';
import type { Campaign } from '~/types/graphql';

export enum ETemplateStatus {
  NORMAL = 'NORMAL',
  UNPUBLISHED = 'UNPUBLISHED',
  DELETED = 'DELETED',
}

export interface TemplateStatusInfo {
  variant: VariantWithTemplateSelectFragment;
  campaign: Campaign;
  status: ETemplateStatus;
  name: string;
}
